import { createActions } from 'redux-actions';

import keyGenerator from 'utils/keys';

import types from 'state/shipments/actionTypes';

const { shipments } = createActions({
  [types.CHANGE_VALUES]: ({ values, shipmentKey = 0 }) => ({
    values,
    shipmentKey,
  }),

  [types.SET_EXTRA]: ({ shipmentKey, stopType, extra }) => ({
    shipmentKey,
    stopType,
    extra,
  }),

  [types.changeExtras$]: ({ shipmentKey, stopType, extra }) => ({
    shipmentKey,
    stopType,
    extra,
  }),

  [types.changeTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.selectTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.onBlurTimePicker$]: ({ stopType, timeParam, value, shipmentKey }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
  }),

  [types.changeDate$]: ({ stopType, value, shipmentKey }) => ({
    stopType,
    value,
    shipmentKey,
  }),

  [types.changeAddress$]: ({
    stopType,
    shipmentKey,
    address,
    rawAddress,
    rawKey,
    key,
  }) => ({
    stopType,
    shipmentKey,
    address,
    rawAddress,
    rawKey,
    key,
  }),
  [types.setDefaults$]: ({
    stopType,
    shipmentKey,
    forceSetDefaults = false,
    orderType,
    customKeys,
    pickupDate = false,
  }) => ({
    stopType,
    shipmentKey,
    forceSetDefaults,
    orderType,
    customKeys,
    pickupDate,
  }),

  [types.SET_COMMENT_FOR_TRANSPORTIST]: ({
    commentForTransportist,
    stopType,
    shipmentKey,
  }) => ({
    commentForTransportist,
    shipmentKey,
    stopType,
  }),
  [types.SET_INTERNAL_REFERENCE]: ({ value, stopType, shipmentKey }) => ({
    internalReference: value,
    shipmentKey,
    stopType,
  }),
  [types.SET_APPOINTMENT_INSTRUCTIONS]: ({ value, shipmentKey }) => ({
    value,
    shipmentKey,
  }),

  [types.createShipment$]: ({ orderType, shipmentKey }) => ({
    shipmentKey: `${orderType}_${shipmentKey || keyGenerator.timestamp()}`,
  }),
  [types.deleteShipment$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),

  [types.ADD_SHIPMENT]: ({ shipmentKey, values = {} }) => ({
    shipmentKey: `${shipmentKey || keyGenerator.timestamp()}`,
    values,
  }),
  [types.REMOVE_SHIPMENT]: ({ shipmentKey }) => ({
    shipmentKey,
  }),
  [types.CLEAN_COMMENTS_AND_INTERNAL_REFERENCE]: ({
    stopType,
    shipmentKey,
  }) => ({
    stopType,
    shipmentKey,
  }),
  [types.prepareForRecurringQuote$]: () => ({}),
});

const actions = shipments;

export { actions };
export default shipments;
